<template>
  <email-template-edit-create :organization-id="organization.id" />
</template>

<script>
import Vue from 'vue';
import EmailTemplateEditCreate from '~/pages/shared/email-templates/partials/EditCreate.vue';

export default Vue.extend({
  components: {
    EmailTemplateEditCreate,
  },

  middleware: 'admin',
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
});
</script>
